//////////////// Product tab //////////////
document.addEventListener('DOMContentLoaded', () => {



    /////////////// According Smooth Toggle Animation //////////////
    class Accordion {
        constructor(el) {
            // Store the <details> element
            this.el = el;
            // Store the <summary> element
            this.summary = el.querySelector('summary');
            // Store the <div class="content"> element
            this.content = el.querySelector('.accordion__content');
        
            // Store the animation object (so we can cancel it if needed)
            this.animation = null;
            // Store if the element is closing
            this.isClosing = false;
            // Store if the element is expanding
            this.isExpanding = false;
            // Detect user clicks on the summary element
            this.summary.addEventListener('click', (e) => this.onClick(e));
        }
        
        onClick(e) {
            // Stop default behaviour from the browser
            e.preventDefault();
            // Add an overflow on the <details> to avoid content overflowing
            this.el.style.overflow = 'hidden';
            // Check if the element is being closed or is already closed
            if (this.isClosing || !this.el.open) {
            this.open();
            // Check if the element is being openned or is already open
            } else if (this.isExpanding || this.el.open) {
            this.shrink();
            }
        }
        
        shrink() {
            // Set the element as "being closed"
            this.isClosing = true;
            
            // Store the current height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the height of the summary
            const endHeight = `${this.summary.offsetHeight}px`;
            
            // If there is already an animation running
            if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
            }
            
            // Start a WAAPI animation
            this.animation = this.el.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
            }, {
            duration: 400,
            easing: 'ease-out'
            });
            
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(false);
            // If the animation is cancelled, isClosing variable is set to false
            this.animation.oncancel = () => this.isClosing = false;
        }
        
        open() {
            // Apply a fixed height on the element
            this.el.style.height = `${this.el.offsetHeight}px`;
            // Force the [open] attribute on the details element
            this.el.open = true;
            // Wait for the next frame to call the expand function
            window.requestAnimationFrame(() => this.expand());
        }
        
        expand() {
            // Set the element as "being expanding"
            this.isExpanding = true;
            // Get the current fixed height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the open height of the element (summary height + content height)
            const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
            
            // If there is already an animation running
            if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
            }
            
            // Start a WAAPI animation
            this.animation = this.el.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
            }, {
            duration: 400,
            easing: 'ease-out'
            });
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(true);
            // If the animation is cancelled, isExpanding variable is set to false
            this.animation.oncancel = () => this.isExpanding = false;
        }
        
        onAnimationFinish(open) {
            // Set the open attribute based on the parameter
            this.el.open = open;
            // Clear the stored animation
            this.animation = null;
            // Reset isClosing & isExpanding
            this.isClosing = false;
            this.isExpanding = false;
            // Remove the overflow hidden and the fixed height
            this.el.style.height = this.el.style.overflow = '';
        }
    }

    document.querySelectorAll('.accordion.smooth details').forEach((el) => {
        new Accordion(el);
    });


    /////////////// Close Exsting According //////////////
    class AccordionToggle {
        constructor(el, accordionGroup) {
          this.el = el;
          this.summary = el.querySelector('summary');
          this.content = el.querySelector('.accordion__content');
          
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          this.accordionGroup = accordionGroup;
          
          // Set aria-expanded based on the initial open state
          this.updateAriaExpanded(this.el.open);
          
          this.summary.addEventListener('click', (e) => this.onClick(e));
        }
      
        onClick(e) {
          e.preventDefault();
          this.el.style.overflow = 'hidden';
    
          // Close all other accordions
          this.accordionGroup.closeAllExcept(this);
    
          if (this.isClosing || !this.el.open) {
            this.open();
          } else if (this.isExpanding || this.el.open) {
            this.shrink();
          }
        }
      
        shrink() {
          this.isClosing = true;
          const startHeight = `${this.el.offsetHeight}px`;
          const endHeight = `${this.summary.offsetHeight}px`;
    
          if (this.animation) {
            this.animation.cancel();
          }
    
          this.animation = this.el.animate({
            height: [startHeight, endHeight]
          }, {
            duration: 400,
            easing: 'ease-out'
          });
    
          this.animation.onfinish = () => this.onAnimationFinish(false);
          this.animation.oncancel = () => this.isClosing = false;
        }
      
        open() {
          this.el.style.height = `${this.el.offsetHeight}px`;
          this.el.open = true;
          
          this.accordionGroup.currentAccordion = this;
      
          window.requestAnimationFrame(() => this.expand());
        }
      
        expand() {
          this.isExpanding = true;
          const startHeight = `${this.el.offsetHeight}px`;
          const endHeight = `${this.summary.offsetHeight + this.content.scrollHeight}px`; // Use scrollHeight for precise measurement
    
          if (this.animation) {
            this.animation.cancel();
          }
    
          this.animation = this.el.animate({
            height: [startHeight, endHeight]
          }, {
            duration: 400,
            easing: 'ease-out'
          });
    
          this.animation.onfinish = () => this.onAnimationFinish(true);
          this.animation.oncancel = () => this.isExpanding = false;
        }
      
        onAnimationFinish(open) {
          this.el.open = open;
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          this.el.style.height = '';
          this.el.style.overflow = '';
    
          this.updateAriaExpanded(open);
          
          if (!open) {
            this.accordionGroup.currentAccordion = null;
          }
        }
      
        updateAriaExpanded(isExpanded) {
          this.summary.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        }
      
        close() {
          if (this.el.open) {
            this.shrink();
          }
        }
      }
      
      class AccordionGroup {
        constructor() {
          this.currentAccordion = null;
          this.accordions = [];
        }
      
        init() {
          document.querySelectorAll('.accordion.smooth details').forEach(el => {
            //el.open = false;
            const accordion = new AccordionToggle(el, this);
            this.accordions.push(accordion);
          });
        }
      
        closeAllExcept(currentAccordion) {
          this.accordions.forEach(accordion => {
            if (accordion !== currentAccordion) {
              accordion.close();
            }
          });
        }
    }

    const accordionGroup = new AccordionGroup();
    accordionGroup.init();

    
});  




const slider = document.querySelector('.thumbnail-slider .thumbnail-list');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 1;
  slider.scrollLeft = scrollLeft - walk;
  console.log(walk);
});


